import { appendSnsBtns } from "../functions/sns";
import { displayToTopBtn } from "../functions/guide_contents";
import { scrollToTop } from "../functions/others";
import triggerEcommerceTracking from "../functions/triggerEcommerceTracking";

/* ---------------------------------------------------------
 PC、SP検索系全体
--------------------------------------------------------- */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.search").length) return;
});
/* ---------------------------------------------------------
 PC、SP検索結果
--------------------------------------------------------- */
$(() => {
  if (
    !$(
      `body.search.searchresult, body.seach_for_company.show, ${bookmark_recent_selector}`
    ).length
  )
    return;
  storeUtmCampaignDataToLocalStorage();
  appendSnsBtns();
  scrollToTop();
  displayToTopBtn();
  hideClosingArticle();
  window.addEventListener("react_rendering", () => {
    hideClosingArticle();
  });
});

/* ---------------------------------------------------------
 PC、SPこだわり検索
--------------------------------------------------------- */
$(() => {
  if (!$("body.search.detail_search").length) return;
});

// 「/tokyo」⇒東京に初めからチェック、などを実行
function setFormConditions() {
  const { checked_ids_all } = gon;
  for (var key in checked_ids_all) {
    if (key == "start_date" || key == "end_date") {
      $(`#${key}`).val(checked_ids_all[key]);
    } else if ((key == "online") & checked_ids_all.online) {
      $("#online").prop("checked", true).change();
    } else if ((key == "can_join_faraway") & checked_ids_all.can_join_faraway) {
      $("#can_join_faraway").prop("checked", true).change();
    } else if ($.isArray(checked_ids_all[key])) {
      $.each(checked_ids_all[key], (i, id) => {
        const target_checkbox = $(`#${key}_${id}`);
        target_checkbox.prop("checked", true).change();
      });
    }
  }
  return false;
}

/* ---------------------------------------------------------
 PC、SPお気に入り
--------------------------------------------------------- */
$(() => {
  if (!$("body.search.bookmark").length) return;
  // NOTE: お気に入りのeコマーストラッキング用
  setTimeout(() =>
    triggerEcommerceTracking("gtmBookmarkList", "person", {
      globalIndex: true,
      itemsPerPage: 30,
    })
  );
});

/* ---------------------------------------------------------
 PC、SP最近みた募集
--------------------------------------------------------- */
$(() => {
  if (!$("body.search.recent").length) return;
  // NOTE: 最近みた募集のeコマーストラッキング用
  setTimeout(() =>
    triggerEcommerceTracking("gtmRecentList", "person", {
      globalIndex: true,
      itemsPerPage: 30,
    })
  );
});

// /shubuyaku のような「市区町村」のチェックボックスを後から挿入
function appendCityCheckBoxes() {
  if (gon.selected_cities === undefined) {
    return false;
  }
  const city_checkbox_zone = $("#jsSelectedCity");
  const city_checkboxes = [];
  gon.selected_cities.forEach((city) => {
    city_checkboxes.push(buildcityCheckBoxHtml(city.id, city.name));
  });
  const checkbox_html = `<li class='modalCheckAll'>選択中の市区町村</li><ul class="searchList">${city_checkboxes.join(
    ""
  )}</ul>`;
  city_checkbox_zone.replaceWith(checkbox_html);
  return false;
}
function buildcityCheckBoxHtml(id, name) {
  return `<li class="domesticListArea"><label><input checked type="checkbox" name="area[]" id="area_${id}" value="${id}">${name}</label></li>`;
}

// 費用での絞り込み時の挙動
function changeMoneySelect() {
  const moneyVal = $("#jsMoneySelect option:selected").val();
  $("#jsMoneyCheckbox").find("input:checked").prop("checked", false);

  if (moneyVal == "0") {
    $("#price_1").prop("checked", true);
  } else if (moneyVal == "1") {
    $("#price_1, #price_2").prop("checked", true);
  } else if (moneyVal == "2") {
    $("#price_1, #price_2, #price_3").prop("checked", true);
  } else if (moneyVal == "3") {
    $("#price_1, #price_2, #price_3, #price_4").prop("checked", true);
  } else if (moneyVal == "4") {
    $("#price_1, #price_2, #price_3, #price_4, #price_5").prop("checked", true);
  } else if (moneyVal == "5") {
    $("#price_1, #price_2, #price_3, #price_4, #price_5, #price_6").prop(
      "checked",
      true
    );
  } else if (moneyVal == "6") {
    $(
      "#price_1, #price_2, #price_3, #price_4, #price_5, #price_6, #price_7"
    ).prop("checked", true);
  } else if (moneyVal == "7") {
    $(
      "#price_1, #price_2, #price_3, #price_4, #price_5, #price_6, #price_7, #price_8"
    ).prop("checked", true);
  } else if (moneyVal == "8") {
    $(
      "#price_1, #price_2, #price_3, #price_4, #price_5, #price_6, #price_7, #price_8, #price_9"
    ).prop("checked", true);
  } else if (moneyVal == "9") {
    $("#price_10, #price_11").prop("checked", true);
  } else if (moneyVal == "10") {
    $("#price_11").prop("checked", true);
  }
}

function toUnderscoreCase(str) {
  return str
    .split(/(?=[A-Z])/)
    .join("_")
    .toLowerCase();
}

function changeSelectOf(rangeType, query) {
  const underscoreQuery = toUnderscoreCase(query);
  const val = $(`#js${query}${rangeType}Select option:selected`).val();
  $(`#js${query}${rangeType}CheckBox`)
    .find("input:checked")
    .prop("checked", false);
  $(`#${underscoreQuery}_${rangeType.toLowerCase()}_${val}`).prop(
    "checked",
    true
  );
}

function toggleDisplayOfLte(query) {
  const val = $(`#js${query}GteSelect option:selected`).val();
  $(`#js${query}LteSelect`)
    .children("option")
    .each(function () {
      if (Number(val) > Number($(this).val())) {
        $(this).css("display", "none");
      } else {
        $(this).css("display", "block");
      }
    });
}

function toggleDisplayOfGte(query) {
  const val = $(`#js${query}LteSelect option:selected`).val();
  $(`#js${query}GteSelect`)
    .children("option")
    .each(function () {
      if (Number($(this).val()) > Number(val)) {
        $(this).css("display", "none");
      } else {
        $(this).css("display", "block");
      }
    });
}

function showCheckedItemName(checkedItem) {
  const checkItemList = $(checkedItem).closest("ul.jsParentUl");
  const checkedItemArray = checkItemList
    .find("input:checked[value]")
    .parent()
    .map(function () {
      return $(this)
        .text()
        .replace(/\([0-9]+\)$/, "");
    });
  const appendText =
    checkedItemArray.length == 0
      ? "指定なし"
      : Array.prototype.join.call(checkedItemArray, ",");
  $(`#jsSelected${checkItemList.data("condition")}`)
    .text(appendText)
    .addClass("isChecked");
}

function checkAll(targetCheckBoxes, checkedItem) {
  if (checkedItem.checked) {
    targetCheckBoxes.prop("checked", "checked").change();
  } else {
    targetCheckBoxes.prop("checked", false).change();
  }
}

// 募集中のarticleが30件未満の場合は募集終了をアコーディオンで隠す
const hideClosingArticle = () => {
  const initializeClosingArticle = () => {
    $("#jsAccordionClosingArticleSwitch").remove();
    $(".jsAccordionElement").show();
    $(".jsAccordionElement").removeClass("jsAccordionElement");
    $(".secondClosingArticle").removeClass("secondClosingArticle");
  };

  const setAccordion = () => {
    const allClosingArticle = document.querySelectorAll(".jsClosingArticle");
    const secondClosingArticle = allClosingArticle[1];
    secondClosingArticle.setAttribute("id", "jsSecondClosingArticle");
    secondClosingArticle.classList.add("secondClosingArticle");
    const accordion = document.createElement("div");
    accordion.id = "jsAccordionClosingArticleSwitch";
    accordion.classList.add("accordionClosingArticleSwitch", "p_btn", "isSub");
    const accordionText = document.createElement("p");
    const accordionContent =
      document.createTextNode("終了した募集をもっと見る");
    accordionText.appendChild(accordionContent);
    accordion.insertBefore(accordionText, accordion.firstChild);
    $("#jsSecondClosingArticle")
      .nextUntil(".jsPagenaviZone")
      .addClass("jsAccordionElement");
    secondClosingArticle.after(accordion);
    const reactPagenaviZone = $("#jsMainSearch .jsPagenaviZone");
    $("body.pc.search.searchresult").length
      ? reactPagenaviZone.eq(1).addClass("jsAccordionElement")
      : reactPagenaviZone.eq(0).addClass("jsAccordionElement");
    $(".jsAccordionElement").hide();
    $("#jsAccordionClosingArticleSwitch").on("click", () => {
      $(".jsAccordionElement").slideToggle();
      $("#jsAccordionClosingArticleSwitch").remove();
      secondClosingArticle.classList.remove("secondClosingArticle");
    });
  };
  initializeClosingArticle();
  const page = Number($.getParameter().page) || 1;
  if (document.querySelector(".jsPublishArticleCountIsSmallNum") && page == 1) {
    setAccordion();
  }
};

// NOTE: 2023/6現在、日本郵政様のチラシ経由の応募の計測用途のみ
function storeUtmCampaignDataToLocalStorage() {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("utm_campaign") === "post_office") {
    const utmCampaign = urlParams.get("utm_campaign");
    const utmMedium = urlParams.get("utm_medium");
    const utmSource = urlParams.get("utm_source");

    localStorage.setItem("utm_campaign", utmCampaign);
    localStorage.setItem("utm_medium", utmMedium);
    localStorage.setItem("utm_source", utmSource);
  }
}

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export {
  setFormConditions,
  appendCityCheckBoxes,
  buildcityCheckBoxHtml,
  changeMoneySelect,
  changeSelectOf,
  toggleDisplayOfLte,
  toggleDisplayOfGte,
  showCheckedItemName,
  checkAll,
  storeUtmCampaignDataToLocalStorage,
};
